import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { roleGuard } from '@core/guards/role.guard';
import { AppRole } from '@core/models/permission.model';


export const routes: Routes = [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },

    // Inventory feature
    {
        path: 'dashboard',
        loadComponent: () => import('@features/inventory-dashboard/pages/dashboard.page').then(m => m.DashboardPage),
        canActivate: [authGuard]
    },

    // Planning feature
    {
        path: 'planning/status',
        loadComponent: () => import('@features/inventory-planning/pages/stock-status.page').then(m => m.StockStatusPage),
        canActivate: [authGuard]
    },
    {
        path: 'planning/replenishment',
        loadComponent: () => import('@features/inventory-planning/pages/replenishment.page').then(m => m.ReplenishmentPage),
        canActivate: [authGuard]
    },
    {
        path: 'planning/rules',
        loadComponent: () => import('@features/inventory-planning/pages/reorder-rules.page').then(m => m.ReorderRulesPage),
        canActivate: [authGuard, roleGuard([AppRole.ADMIN, AppRole.CHEF])]
    },

    {
        path: 'products/detail',
        loadComponent: () => import('@features/inventory-products/pages/product-detail.page').then(m => m.ProductDetailPage),
        canActivate: [authGuard]
    },

    // Admin - Suppliers
    {
        path: 'admin/suppliers',
        loadComponent: () => import('@features/inventory-suppliers/pages/supplier-list.page').then(m => m.SupplierListPage),
        canActivate: [authGuard, roleGuard([AppRole.ADMIN, AppRole.CHEF])]
    },
    {
        path: 'admin/suppliers/create',
        loadComponent: () => import('@features/inventory-suppliers/pages/supplier-create.page').then(m => m.SupplierCreatePage),
        canActivate: [authGuard, roleGuard([AppRole.ADMIN, AppRole.CHEF])]
    },
    {
        path: 'admin/suppliers/:id',
        loadComponent: () => import('@features/inventory-suppliers/pages/supplier-detail.page').then(m => m.SupplierDetailPage),
        canActivate: [authGuard, roleGuard([AppRole.ADMIN, AppRole.CHEF])]
    },

    // Error pages
    {
        path: 'unauthorized',
        loadComponent: () => import('./pages/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
    },
    {
        path: '404',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
    },

    // Wildcard route - must be last
    {
        path: '**',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
    },
];
